module.exports = __webpack_public_path__ + "static/img/warehouse2.69e436b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/warehouse2.png
// module id = +y5P
// module chunks = 1